import { render, staticRenderFns } from "./SiteMvrChecks.vue?vue&type=template&id=501bb15e&scoped=true"
import script from "./SiteMvrChecks.vue?vue&type=script&lang=js"
export * from "./SiteMvrChecks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501bb15e",
  null
  
)

export default component.exports